'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _nav = require('./nav.conf');

var _nav2 = _interopRequireDefault(_nav);

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      navList: [],
      currentName: false,
      currentView: ''
    };
  },
  created: function created() {
    this.getListScope();
    this.navList = _nav2.default.call(this);
  },

  watch: {
    '$route': function $route() {
      // 动态特殊处理，避免影响之前业务逻辑
      // if (this.$route.path === '/dynamicList') {
      //   this.currentView = 'course'
      //   return
      // }
      var arr = this.$route.path.split('/');
      arr.forEach(function (item, index) {
        if (item == '') {
          arr.splice(index, 1);
        }
      });
      this.currentView = arr[0];
    }
  },
  methods: {
    //显示、隐藏
    visibleChange: function visibleChange(arg, index) {
      var status = arg[0];
      this.$set(this.navList[index], 'active', status);
    },

    //获取当前用户管理范围
    getListScope: function getListScope() {
      var _this = this;

      this.$ajax({
        url: 'user/listScope',
        type: 'GET',
        preventMessage: true
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 2000) {
          _this.navList = _nav2.default.call(_this);
        }
      });
    },

    //研讨、发现的下拉跳转
    dropMenu: function dropMenu(item) {
      var name = item.name;
      var classIds = localStorage.getItem('currentClasses') ? JSON.parse(localStorage.getItem('currentClasses')) : [];
      if (item.name == '/class/class-detail') {
        item.query = item.query || {};
        if (classIds.length > 1) {
          name = '/class/class-list';
        } else if (classIds.length == 1) {
          item.query.classID = classIds[0];
        } else {
          name = '/class/class-list';
          item.query.type = 'history';
        }
      }
      this.$router.push({
        path: name,
        query: (0, _assign2.default)({
          type: item.value
        }, item.query || {})
      });
    },
    openAdmin: function openAdmin() {
      window.open('./admin');
    }
  },
  components: {
    IconFont: _iconfont2.default
  }
};